import styled from '@emotion/styled'

import { BaseImage } from './BaseImage'

export const FittedImage = styled(BaseImage)({
  objectFit: 'cover',
})
